import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
export function LetterSection() {
  const {
    ref,
    isVisible
  } = useScrollAnimation(0.1);
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0
    }
  };
  return <section className="py-16 md:py-24 bg-[#F8FAFC] text-gray-900" data-id="element-125">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-126">
        <motion.div ref={ref} initial="hidden" animate={isVisible ? 'visible' : 'hidden'} variants={containerVariants} className="space-y-6 md:space-y-8" data-id="element-127">
          {/* Header */}
          <motion.div variants={itemVariants} className="flex items-center gap-4 mb-8 md:mb-12 border-b border-gray-200 pb-6 md:pb-8" data-id="element-128">
            <div className="w-14 h-14 md:w-16 md:h-16 bg-purple-600 rounded-full flex items-center justify-center flex-shrink-0 text-white font-bold text-xl md:text-2xl border-4 border-purple-200" data-id="element-129">
              CC
            </div>
            <div data-id="element-130">
              <p className="font-bold text-base md:text-lg" data-id="element-131">
                Desde el escritorio de Claudio Conde
              </p>
              <p className="text-gray-500 text-sm" data-id="element-132">
                Re: Tu ROAS depende del creativo
              </p>
            </div>
          </motion.div>

          {/* Body */}
          <motion.p variants={itemVariants} className="text-lg md:text-xl font-medium text-gray-800" data-id="element-133">
            Si vendés infoproductos, aceptá la verdad:{' '}
            <span className="bg-yellow-100 px-1" data-id="element-134">
              El targeting ya no importa tanto. El creativo es todo.
            </span>
          </motion.p>

          <motion.p variants={itemVariants} className="text-base md:text-lg text-gray-700" data-id="element-135">
            Pero hoy estás trabado:
          </motion.p>

          <motion.ul variants={itemVariants} className="space-y-4 pl-4 border-l-4 border-purple-500 bg-white p-6 rounded-r-xl shadow-sm" data-id="element-136">
            <li className="flex gap-3" data-id="element-137">
              <span className="text-xl md:text-2xl" data-id="element-138">⏳</span>
              <span className="text-base md:text-lg text-gray-700" data-id="element-139">
                <strong data-id="element-140">Perdés horas</strong> haciendo prompts en IA para
                resultados mediocres.
              </span>
            </li>
            <li className="flex gap-3" data-id="element-141">
              <span className="text-xl md:text-2xl" data-id="element-142">🎲</span>
              <span className="text-base md:text-lg text-gray-700" data-id="element-143">
                <strong data-id="element-144">Testeás poco</strong> (5-10 creativos/sem) y rezás que
                uno funcione.
              </span>
            </li>
            <li className="flex gap-3" data-id="element-145">
              <span className="text-xl md:text-2xl" data-id="element-146">📉</span>
              <span className="text-base md:text-lg text-gray-700" data-id="element-147">
                <strong data-id="element-148">Tu test no arranca</strong> real porque nunca tenés
                volumen suficiente.
              </span>
            </li>
          </motion.ul>

          <motion.h3 variants={itemVariants} className="text-2xl md:text-3xl font-bold text-gray-900 pt-4" data-id="element-149">
            Necesitás 100 creativos.
          </motion.h3>

          <motion.p variants={itemVariants} className="text-base md:text-lg text-gray-700" data-id="element-150">
            La matemática es simple:{' '}
            <strong data-id="element-151">Solo 2 de cada 100 creativos la rompen.</strong>
          </motion.p>

          <motion.p variants={itemVariants} className="text-lg md:text-xl font-medium text-gray-900" data-id="element-152">
            Si testeás 5, es lotería. <br data-id="element-153" />
            <span className="text-purple-600 font-bold" data-id="element-154">
              Si testeás 100, es estadística.
            </span>
          </motion.p>

          <motion.div variants={itemVariants} className="pt-8 text-center" data-id="element-155">
            <a href="#pricing" className="inline-block bg-purple-600 hover:bg-purple-700 text-white font-bold py-3 px-8 rounded-full transition-colors shadow-lg hover:shadow-xl transform hover:-translate-y-1" data-id="element-156">
              ACCEDER A LA APP →
            </a>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}